import styleReducers from './reducers';
export { default as styleOperations } from './operations';
export { default as styleTypes } from './types';
export default styleReducers;
